import { handleImageInput, withSBErrorHandling } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotTiffGeneratorImpl = {
    async generateFromImages(params) {
        return withSBErrorHandling(async () => {
            return (await ScanbotSDKPlugin.generateTiffFromImages({
                tiffGeneratorParameters: params.tiffGeneratorParameters,
                images: handleImageInput(params.images),
            })).result;
        });
    },
    async generateFromDocument(params) {
        return withSBErrorHandling(async () => {
            return (await ScanbotSDKPlugin.generateTiffFromDocument(params)).result;
        });
    },
};
//# sourceMappingURL=TiffGeneratorImpl.js.map